import { downloadUrl } from "../../api/media.js";

export function DownloadButton({ mediaId, className }: { mediaId: string; className?: string }) {
  return (
    <a
      className={className ?? "btn btn-secondary"}
      href={downloadUrl(mediaId)}
      download
      onClick={(e) => e.stopPropagation()}
    >
      Télécharger
    </a>
  );
}
